import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Skeleton, TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
};

export default function RHFTextField({ name, disable, loading = false, shrink, autocomplete, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) =>
        loading ? (
          <Skeleton sx={{ fontSize: '2rem' }} width={'100%'}>
            <TextField />
          </Skeleton>
        ) : (
          <TextField
            {...field}
            disabled={disable}
            fullWidth
            value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
            error={!!error}
            helperText={error?.message}
            InputLabelProps={{ shrink: shrink===null?false:shrink }}
            autoComplete={autocomplete?'on':'off'}
            {...other}
          />
        )
      }
    />
  );
}
